module.exports = __webpack_public_path__ + "static/app-70d8324fa82c27600b426dfe5a32c3a5.svg";